/**
 * Mote — voice notes and feedback
 *
 * Declares one web-accessible-resource entry matched to every origin with no
 * `use_dynamic_url`, exposing broad directory globs (`images/*`, `worklets/*`,
 * `models/*`) plus named entry points (`popup.html`, `static/js/popup.js`). All are
 * reachable from any page at a fixed URL. The icons under `images/icons/` load through
 * `probeImage` with no CORS grant, so a load survives a restrictive page CSP.
 *
 * Manifest verified against version 3.3.0.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ajphlblkfpppdpkgokiejbjfohfohhmk';

export const mote: ExtensionDefinition = {
  id: ID,
  name: 'Mote for Google Chrome™',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 400_000,
  notes:
    'Broad static WAR globs on every origin with no dynamic URL. The images/icons PNGs ' +
    'load without a CORS grant and are conclusive.',
  signals: [
    {
      id: 'war-icon-profile',
      kind: 'web-accessible-resource',
      description:
        'Load images/icons/profile.png via <img> — a packaged icon exposed to every ' +
        'origin, readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'images/icons/profile.png'),
    },
    {
      id: 'war-popup-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch popup.html — a named static entry point exposed to every origin.',
      weight: 0.5,
      run: () => probeFetch(ID, 'popup.html'),
    },
    {
      id: 'war-popup-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch static/js/popup.js — a stable named script path, independent of the ' +
        'icon and HTML.',
      weight: 0.5,
      run: () => probeFetch(ID, 'static/js/popup.js'),
    },
  ],
};
